module.exports = __webpack_public_path__ + "img/ico-contacta-con-nosotros.031fbc6a.png";